import script from "./BidForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidForm.vue?vue&type=script&setup=true&lang=ts"

import "./BidForm.vue?vue&type=style&index=0&id=5a4e4b9d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a4e4b9d"]])

export default __exports__